import {EventBus} from "../../../../../../common/ts/events/EventBus";
import {
    SaveEmailAlertRequestedEvent,ShowSaveSearchModalEvent,ShowRetentionPopupMobileRequestedEvent,ShowRetentionCaptureModalRequestedEvent
} from "./events";
import {FullPageModalOpenEvent, WhitelabelEvent} from "../../../../../../common/ts/events/Events";
import {
    EMAIL_RETENTION_ALERTS_LOCAL_STORAGE_KEY,
    EMAIL_RETENTION_FORM_IDS,
    EMAIL_RETENTION_POPUP_MOBILE,
    EMAIL_RETENTION_POPUP_MOBILE_FORM,
    SAVE_SEARCH_MODAL
} from "./constants";
import {PopulateFormEvent, ShowEvent} from "../../../../../../common/ts/core/dom";
import apiClassic from "../../../../apiClassic";
import {SetItemEvent} from "../../../../../../common/ts/core/localStorage";

let eventBus: EventBus;

export function saveEmailAlertRequestedEventHandler(event: WhitelabelEvent) {
    const {payload: {searches, email, wantNews, successEvent}} = event as SaveEmailAlertRequestedEvent;

    if (email && !localStorage.getItem("email")) {
        localStorage.setItem("email", email);

        EMAIL_RETENTION_FORM_IDS.forEach(formId => {
            eventBus.emit(new PopulateFormEvent({
                selector: `#${formId}`,
                data: [["email", localStorage.getItem("email")]],
            }));
        });
    }

    eventBus.emit(apiClassic.events.createMultipleEmailAlerts({searches, email, wantNews, successEvent}));
    searches.forEach(search => updateSavedSearches(search, localStorage.getItem(EMAIL_RETENTION_ALERTS_LOCAL_STORAGE_KEY)));
}

function updateSavedSearches(search: string, storedSearches: string | null) {
    let searchesToSave: string[] = [];
    if (storedSearches) {
        const parsedSearches = JSON.parse(storedSearches);
        parsedSearches.push(search);
        searchesToSave = parsedSearches;
    } else {
        searchesToSave = [search];
    }

    if (searchesToSave.length > 0) {
        eventBus.emit(new SetItemEvent({
            key: EMAIL_RETENTION_ALERTS_LOCAL_STORAGE_KEY,
            value: JSON.stringify(searchesToSave)
        }));
    }
}

export function showRetentionPopupMobileRequestedEventHandler() {
    eventBus.emit(new PopulateFormEvent({
        selector: EMAIL_RETENTION_POPUP_MOBILE_FORM,
        data: [["email", localStorage.getItem("email")]],
    }));

    eventBus.emit(new ShowEvent({ selector: EMAIL_RETENTION_POPUP_MOBILE }));
}

export function showSaveSearchModalHandler(event: WhitelabelEvent) {
    const { payload: { saveSearchModal: saveSearchModal } } = event as ShowSaveSearchModalEvent;
    saveSearchModal.openModal();
}

export function showRetentionCaptureModalRequestedEventHandler(event: WhitelabelEvent) {
    eventBus.emit(new PopulateFormEvent({
        selector: "#js-email-retention-form",
        data: [['email', localStorage.getItem("email")]],
    }))

    eventBus.emit(new FullPageModalOpenEvent({
        id: SAVE_SEARCH_MODAL,
    }));
}


function init(ev: any = EventBus.getInstance()) {
    eventBus = ev;
    eventBus.subscribe(SaveEmailAlertRequestedEvent.TYPE, saveEmailAlertRequestedEventHandler);
    eventBus.subscribe(ShowRetentionCaptureModalRequestedEvent.TYPE, showRetentionCaptureModalRequestedEventHandler);
    eventBus.subscribe(ShowRetentionPopupMobileRequestedEvent.TYPE, showRetentionPopupMobileRequestedEventHandler);
    eventBus.subscribe(ShowSaveSearchModalEvent.TYPE, showSaveSearchModalHandler);
}

export default {
    init,
};
